import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TickXiQ from './TickXiQ';

export default class TickXiQWrapper extends Component {
    render() {
        return(
            <TickXiQ config={this.props.config} />
        );
    }
}

TickXiQWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
